import React from 'react';
import { Form } from 'react-bootstrap';

const TableFilter = ({ filterValue, setFilter }) => {
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
        }
    };

    return (
        <Form className="d-flex">
            <Form.Control
                type="text"
                placeholder="Search..."
                value={filterValue || ''}
                onChange={(e) => setFilter(e.target.value)}
                onKeyDown={handleKeyDown}
            />
        </Form>
    );
}

export default TableFilter;
